import { UsersSetLoginLockReducer } from './types';

export const usersSetLoginLockReducer: UsersSetLoginLockReducer = (
  state,
  action
) => {
  if (!state.currentUser) {
    return state;
  }

  return {
    ...state,
    currentUser: {
      ...state.currentUser,
      isLoginLocked: action.payload,
    },
  };
};
